import Vue from 'vue'
import Vuex from 'vuex'

import Auth from './modules/auth-user'
import Tabs from './modules/tabs'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Auth,
    Tabs
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js